import { z } from "zod";

export const pricingSchema = z.object({
  defaultEpisodePriceThb: z.number().nonnegative(),
  defaultBundlePriceThb: z.number().nonnegative(),
  launchPromoPriceThb: z.number().nonnegative(),
  launchPromoEndAt: z.coerce.date().nullable(),
  freeEpisodeCount: z.number().int().nonnegative(),
  currency: z.literal("THB"),
});

export const deviceCapsSchema = z.object({
  episode: z.number().int().positive(),
  bundle: z.number().int().positive(),
});

export const featureFlagsSchema = z.object({
  maintenanceMode: z.boolean().default(false),
  signupsEnabled: z.boolean().default(true),
  googleOAuthEnabled: z.boolean().default(true),
  promoBannerEnabled: z.boolean().default(true),
  omiseEnabled: z.boolean().default(false),
});

export const pixelsSchema = z.object({
  tiktokPixelId: z.string().optional(),
  metaPixelId: z.string().optional(),
});

export const copyOverridesSchema = z.object({
  paymentModalHeadlineTh: z.string().optional(),
  paymentModalHeadlineEn: z.string().optional(),
  paymentSuccessHeadlineTh: z.string().optional(),
  paymentSuccessHeadlineEn: z.string().optional(),
  receiptFooterTh: z.string().optional(),
  receiptFooterEn: z.string().optional(),
});

export const merchantSchema = z.object({
  companyName: z.string(),
  taxId: z.string(),
  addressTh: z.string(),
  addressEn: z.string(),
  phone: z.string().optional(),
  email: z.string().email(),
});

export const settingsSchema = z.object({
  _id: z.literal("singleton"),
  pricing: pricingSchema,
  deviceCaps: deviceCapsSchema,
  embeddingModel: z.string(),
  flags: featureFlagsSchema,
  pixels: pixelsSchema,
  copy: copyOverridesSchema,
  merchant: merchantSchema,
  supportEmail: z.string().email(),
  updatedAt: z.coerce.date(),
  updatedBy: z.string().optional(),
});

export type Settings = z.infer<typeof settingsSchema>;
